"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const emotion_1 = require("emotion");
const utils_1 = require("./utils");
const sizes = {
    s: '2px',
    m: '4px',
    l: '6px',
    xl: '8px',
};
const ProgressBar = (_a) => {
    var { className, size = 's', type, status, color, value, style } = _a, rest = __rest(_a, ["className", "size", "type", "status", "color", "value", "style"]);
    const progressClasses = emotion_1.cx('progress', className);
    const progressBarClasses = emotion_1.cx('progress-bar', { [`progress-bar-${status || type}`]: status || type });
    const barStyle = color ? { width: `${value}%`, background: color } : { width: `${value}%` };
    const containerStyle = { height: sizes[size] };
    return (react_1.default.createElement("div", Object.assign({ className: progressClasses, style: Object.assign(Object.assign({}, containerStyle), style) }, rest),
        react_1.default.createElement("div", { className: progressBarClasses, style: barStyle })));
};
ProgressBar.propTypes = {
    size: prop_types_1.default.oneOf(['s', 'm', 'l', 'xl']),
    status: prop_types_1.default.oneOf(['success', 'warning', 'danger', 'info']),
    color: prop_types_1.default.string,
    value: (props, propName) => {
        if (typeof props[propName] !== 'number' || props[propName] < 0 || props[propName] > 100) {
            return new Error('value must be a number between 0 and 100');
        }
        return null;
    },
    className: prop_types_1.default.string,
    style: react_style_proptype_1.default,
    type: utils_1.deprecatedProp(prop_types_1.default.oneOf(['success', 'warning', 'danger', 'info']), 'Use `status` instead.'),
};
exports.default = ProgressBar;
